import { api } from '@api/client'

export async function fetchAssets (companyId) {
  const response = await api.get(`/company/${companyId}/assets`)
  return response.data
}
